import T from '../../../common/components/T';
import { A } from '../../../hybrid/wrappers';
import css from '../../single/components/SingleFooter/single-footer.module.scss';

export const footerInfo = {
    phone: '077 980 70 00',
    timeWork: <T textName='storeTimework' defaultStr='с 10:00 до 21:00 без выходных' page='/' />,
    subtitle: [
        <T
            key={Math.random()}
            textName='storeFooterSubtitle1'
            defaultStr='Товарищество с ограниченной ответственностью ТОО «GLOB@L Plus»'
            page='/'
        />,
        <T key={Math.random()} textName='storeFooterSubtitle2' defaultStr='БИН 190540001756' page='/' />,
        <T
            key={Math.random()}
            textName='storeFooterSubtitle3'
            defaultStr='Юридический адрес: 050036, Республика Казахстан, г. Алматы, мкр. Мамыр-7, д.21«А»'
            page='/'
        />
    ],
    social: [
        {
            type: 'instagram',
            link: 'https://www.instagram.com/globaltrend.official/?igshid=1d49f4t3wja7w',
            background: 'linear-gradient(45deg, #FFC107 9.15%, #F44336 50.57%, #9C27B0 90.03%)'
        },
        // {
        //     type: 'facebook',
        //     link: 'https://facebook.com',
        //     background: 'rgba(72,103,170,1)'
        // },
        // {
        //     type: 'twitter',
        //     link: 'https://twitter.com',
        //     background: 'rgba(29,161,242,1)'
        // },
        // {
        //     type: 'whatsapp',
        //     link: 'https://whatsapp.com',
        //     background: 'rgba(39,210,70,1)'
        // },
        {
            type: 'youtube',
            link: 'https://www.youtube.com/channel/UCZRq8VHhgB5vhqaR0t5HsAQ',
            background: 'rgba(255,0,0,1)'
        }
        // {
        //     type: 'telegram',
        //     link: 'https://telegram.com',
        //     background: 'rgba(37,163,225,1)'
        // }
    ]
};

export const footerInfoKz = {
    subtitle: [
        <T key={Math.random()} textName='storeFooterSubtitleCom1-v2_kz' defaultStr='ТОО "Glob@l Plus"' page='/' />,
        <T key={Math.random()} textName='storeFooterSubtitleCom2-v1_kz' defaultStr='ИИН (БИН): 190540001756' page='/' />,
        <T
            key={Math.random()}
            textName='storeFooterSubtitleCom3-v2_kz'
            defaultStr='Юридический адрес: г.Талдыкорган, ул.Назарбаева, 127'
            page='/'
        />,
        <T
            key={Math.random()}
            textName='storeFooterSubtitleCom4-v2_kz'
            defaultStr='Письменые обращения: г.Алматы, Мамыр 7, 21А'
            page='/'
        />,
        // <T key={Math.random()} textName='storeFooterSubtitleCom5-v1' defaultStr='АО "KASPI BANK"' page='/' />,
        // <T key={Math.random()} textName='storeFooterSubtitleCom6-v1' defaultStr='ИИК KZ51722S000002738592' page='/' />,
        // <T key={Math.random()} textName='storeFooterSubtitleCom7-v1' defaultStr='БИК CASPKZKA' page='/' />,
        <p key={Math.random()}>
            <T textName='storeFooterSubtitleCom8-v1_kz' defaultStr='Адрес эл. почты:' page='/' />{' '}
            <A className={css.itemMenuStyle2} href='mailto:support.globaltrend@gmail.com'>
                support.globaltrend@gmail.com
            </A>
        </p>,
        <p key={Math.random()}>
            <T textName='storeFooterSubtitleCom9-v1_kz' defaultStr='Телефон:' page='/' />{' '}
            <A className={css.itemMenuStyle2} href='tel:+77073212121'>
                +7 707 321 21 21
            </A>
        </p>
    ],
    social: [
        {
            type: 'instagram',
            link: 'https://www.instagram.com/globaltrend.official/?igshid=1d49f4t3wja7w',
            background: 'linear-gradient(45deg, #FFC107 9.15%, #F44336 50.57%, #9C27B0 90.03%)'
        },
        // {
        //     type: 'facebook',
        //     link: 'https://facebook.com',
        //     background: 'rgba(72,103,170,1)'
        // },
        // {
        //     type: 'twitter',
        //     link: 'https://twitter.com',
        //     background: 'rgba(29,161,242,1)'
        // },
        // {
        //     type: 'whatsapp',
        //     link: 'https://whatsapp.com',
        //     background: 'rgba(39,210,70,1)'
        // },
        {
            type: 'youtube',
            link: 'https://www.youtube.com/channel/UCZRq8VHhgB5vhqaR0t5HsAQ',
            background: 'rgba(255,0,0,1)'
        },
        {
            type: 'telegram',
            link: 'https://t.me/globaltrendofficial1',
            background: 'rgba(37,163,225,1)'
        }
    ]
};
export const footerInfoKrz = {
    subtitle: [
        <T key={Math.random()} textName='storeFooterSubtitleCom1-v2_Krz' defaultStr='ООО "Глобал Тренд"' page='/' />,
        <T
            key={Math.random()}
            textName='storeFooterSubtitleCom22-v1_Krz'
            defaultStr='Регистрационный номер: 189487-3300-ООО'
            page='/'
        />,
        <T key={Math.random()} textName='storeFooterSubtitleCom222-v1_Krz' defaultStr='Код ОКПО: 30834429' page='/' />,
        <T key={Math.random()} textName='storeFooterSubtitleCom2-v1_Krz' defaultStr='ИИН: 02502202010157' page='/' />,
        <T
            key={Math.random()}
            textName='storeFooterSubtitleCom3-v2_Krz'
            defaultStr='Юридический адрес: Бишкек, Ленинский район, ул.Турусбекова, 109/3'
            page='/'
        />,
        <p key={Math.random()}>
            <T textName='storeFooterSubtitleCom8-v1_Krz' defaultStr='Адрес эл. почты:' page='/' />{' '}
            <A className={css.itemMenuStyle2} href='mailto:globaltrend_kgz@mail.ru'>
                globaltrend_kgz@mail.ru
            </A>
        </p>,
        <p key={Math.random()}>
            <T textName='storeFooterSubtitleCom9-v1_Krz' defaultStr='Телефон:' page='/' />{' '}
            <A className={css.itemMenuStyle2} href='tel:+996502247147'>
                +996 502 247 147
            </A>
        </p>
    ],
    social: [
        {
            type: 'instagram',
            link: 'https://www.instagram.com/globaltrend.official/?igshid=1d49f4t3wja7w',
            background: 'linear-gradient(45deg, #FFC107 9.15%, #F44336 50.57%, #9C27B0 90.03%)'
        },
        // {
        //     type: 'facebook',
        //     link: 'https://facebook.com',
        //     background: 'rgba(72,103,170,1)'
        // },
        // {
        //     type: 'twitter',
        //     link: 'https://twitter.com',
        //     background: 'rgba(29,161,242,1)'
        // },
        // {
        //     type: 'whatsapp',
        //     link: 'https://whatsapp.com',
        //     background: 'rgba(39,210,70,1)'
        // },
        {
            type: 'youtube',
            link: 'https://www.youtube.com/channel/UCZRq8VHhgB5vhqaR0t5HsAQ',
            background: 'rgba(255,0,0,1)'
        },
        {
            type: 'telegram',
            link: 'https://t.me/globaltrendofficial1',
            background: 'rgba(37,163,225,1)'
        }
    ]
};
export const footerInfoUz = {
    subtitle: [
        <T key={Math.random()} textName='storeFooterSubtitleCom1-v2_uz' defaultStr='ООО "GLOBALTREND"' page='/' />,
        <T key={Math.random()} textName='storeFooterSubtitleCom2-v1_uz' defaultStr='ИИН: 311 714 419' page='/' />,
        <T key={Math.random()} textName='storeFooterSubtitleCom3-v1_uz' defaultStr='ОКПО: 30583648' page='/' />,
        <T
            key={Math.random()}
            textName='storeFooterSubtitleCom4-v1_uz'
            defaultStr='Код НДС плательщика: 326010256388'
            page='/'
        />,
        <T
            key={Math.random()}
            textName='storeFooterSubtitleCom3-v2_uz'
            defaultStr='Юридический адрес: г.Ташкент Мирабадский район.,ул.Нукус,86/3'
            page='/'
        />,
        <p key={Math.random()}>
            <T textName='storeFooterSubtitleCom8-v1_uz' defaultStr='Адрес эл. почты:' page='/' />{' '}
            <A className={css.itemMenuStyle2} href='mailto:globaltrendtashkent@mail.ru'>
                globaltrendtashkent@mail.ru
            </A>
        </p>,
        <p key={Math.random()}>
            <T textName='storeFooterSubtitleCom9-v1_uz' defaultStr='Телефон:' page='/' />{' '}
            <A className={css.itemMenuStyle2} href='tel:+998908201996'>
                +998 90 820 1996
            </A>
        </p>
    ],
    social: [
        {
            type: 'instagram',
            link: 'https://www.instagram.com/globaltrend.official/?igshid=1d49f4t3wja7w',
            background: 'linear-gradient(45deg, #FFC107 9.15%, #F44336 50.57%, #9C27B0 90.03%)'
        },
        // {
        //     type: 'facebook',
        //     link: 'https://facebook.com',
        //     background: 'rgba(72,103,170,1)'
        // },
        // {
        //     type: 'twitter',
        //     link: 'https://twitter.com',
        //     background: 'rgba(29,161,242,1)'
        // },
        // {
        //     type: 'whatsapp',
        //     link: 'https://whatsapp.com',
        //     background: 'rgba(39,210,70,1)'
        // },
        {
            type: 'youtube',
            link: 'https://www.youtube.com/channel/UCZRq8VHhgB5vhqaR0t5HsAQ',
            background: 'rgba(255,0,0,1)'
        },
        {
            type: 'telegram',
            link: 'https://t.me/globaltrendofficial1',
            background: 'rgba(37,163,225,1)'
        }
    ]
};
export const footerInfoRu = {
    subtitle: [
        <T key={Math.random()} textName='storeFooterSubtitleRU1' defaultStr='ООО "Глобал Тренд"' page='/' />,
        <T key={Math.random()} textName='storeFooterSubtitleRU2' defaultStr='ИНН: 9725009991' page='/' />,
        <T key={Math.random()} textName='storeFooterSubtitleRU3' defaultStr='КПП: 772501001' page='/' />,
        <T
            key={Math.random()}
            textName='storeFooterSubtitleRU4'
            defaultStr='Юридический адрес компании: г.Москва, улица Ленинская Свобода, д. Д. 19, кв./оф. ПОМЕЩ. 52/3'
            page='/'
        />,
        <p key={Math.random()}>
            <T textName='storeFooterSubtitleCom8-v1_ru' defaultStr='Адрес эл. почты:' page='/' />{' '}
            <A className={css.itemMenuStyle2} href='mailto:globaltrendmoscow@gmail.ru'>
                globaltrendmoscow@gmail.ru
            </A>
        </p>,
        <p key={Math.random()}>
            <T textName='storeFooterSubtitleCom9-v1_ru' defaultStr='Телефон:' page='/' />{' '}
            <A className={css.itemMenuStyle2} href='tel:+7 9801318091'>
                +7 980 131 80 91
            </A>
        </p>
    ],
    social: [
        // {
        //     type: 'instagram',
        //     link: 'https://www.instagram.com/globaltrend.official/?igshid=1d49f4t3wja7w',
        //     background: 'linear-gradient(45deg, #FFC107 9.15%, #F44336 50.57%, #9C27B0 90.03%)'
        // },
        // {
        //     type: 'facebook',
        //     link: 'https://facebook.com',
        //     background: 'rgba(72,103,170,1)'
        // },
        // {
        //     type: 'twitter',
        //     link: 'https://twitter.com',
        //     background: 'rgba(29,161,242,1)'
        // },
        // {
        //     type: 'whatsapp',
        //     link: 'https://whatsapp.com',
        //     background: 'rgba(39,210,70,1)'
        // },
        {
            type: 'youtube',
            link: 'https://www.youtube.com/channel/UCZRq8VHhgB5vhqaR0t5HsAQ',
            background: 'rgba(255,0,0,1)'
        },
        {
            type: 'telegram',
            link: 'https://t.me/globaltrendofficial1',
            background: 'rgba(37,163,225,1)'
        }
    ]
};
